import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ContactFilterTopbar from '../filters/contact_filter_topbar';

import { retrieveCompanies } from "../store/actions/search";

export class CompaniesFilterTopbar extends React.Component {
  static propTypes = {
    companiesCount: PropTypes.number,
    companiesGroups: PropTypes.array,
    pageData: PropTypes.object.isRequired,
    retrieveCompanies: PropTypes.func.isRequired,
    selectedCompaniesGroupIds: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    totalUngroupedCompaniesCount: PropTypes.number.isRequired
  };

  findSelectedGroups(selectedGroupIds, groups, ungroupedCount) {
    if (selectedGroupIds[0] === 'ungrouped') {
      return [{ id: 'ungrouped', name: 'Ungrouped', count: ungroupedCount }];
    } else {
      return groups.filter(group => selectedGroupIds.includes(group.id));
    }
  }

  render() {
    const {
      companiesCount,
      companiesGroups,
      pageData,
      retrieveCompanies,
      selectedCompaniesGroupIds,
      totalUngroupedCompaniesCount
    } = this.props;

    let selectedGroups = [];
    if (companiesGroups && companiesGroups.length > 0) {
      selectedGroups = this.findSelectedGroups(
        selectedCompaniesGroupIds,
        companiesGroups,
        totalUngroupedCompaniesCount
      );
    }

    let selectedGroupCount;
    if (selectedGroups.length === 0) {
      selectedGroupCount = companiesCount;
    } else if (selectedGroups[0].id === 'ungrouped') {
      selectedGroupCount = totalUngroupedCompaniesCount;
    } else {
      selectedGroupCount = selectedGroups.reduce((count, group) => count + group.companyCount, 0);
    }

    return (
      <ContactFilterTopbar
        contactCount={companiesCount}
        groups={companiesGroups}
        isCompany
        pageData={pageData}
        retrieveRecords={retrieveCompanies}
        selectedGroupCount={selectedGroupCount}
        selectedGroups={selectedGroups}
      />
    );
  }
}

const mapStateToProps = state => ({
  companiesCount: state.search.meta.companies.databaseCount,
  companiesGroups: state.companies.groups,
  selectedCompaniesGroupIds: state.query.companyGroupIds,
  totalUngroupedCompaniesCount: state.search.meta.companies.totalUngroupedCount
});

const mapDispatchToProps = {
  retrieveCompanies,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesFilterTopbar);
